import React from 'react';
import clsx from 'clsx';

import './index.scss';

import SpInputTitle from "components/molecules/SpInputTitle";

const SpAccordionRadio = ({
  title,
  label,
  list,
  visible,
}) => {
  return (
    <div className="SpAccordionRadio">
      <div className="sp-accordion-radio-area-wrapper">
        <div className={clsx('sp-cmnt-area', { visible })}>
          <div className="arrowArea"></div>
          <div className="spCollpseAreaBackground">
            <SpInputTitle
              title={title}
              label={label}
              list={list}
              type="RadioInput"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpAccordionRadio;